import { render } from "./AsInput.vue?vue&type=template&id=3ecfed68&ts=true"
import script from "./AsInput.vue?vue&type=script&lang=ts"
export * from "./AsInput.vue?vue&type=script&lang=ts"

import "./AsInput.vue?vue&type=style&index=0&id=3ecfed68&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__